<template>
  <div class="container-xl vacancy-list p-0 pt-10" v-if="vacancy">
    <vacancy-full :item="vacancy" no-scroll force-focus />
  </div>
</template>

<script>
import companyMixin from "@state/company";
import vacancyMixin from "@state/vacancy";
import { SearchIcon } from "@vue-hero-icons/solid";
import VacancyFull from "@blocks/vacancy/VacancyFull.vue";
import { ArrowLeftIcon } from "@vue-hero-icons/outline";

export default {
  mixins: [companyMixin, vacancyMixin],
  components: {
    VacancyFull,
    ArrowLeftIcon,
    SearchIcon,
  },
  props: {
    vacancyId: Number | String,
  },
  data() {
    return {
      config: null,
      currentRoute: window.location.href,
      vacancy: null,
      related: null,
    };
  },
  created() {
    this.vacancies
      .read(this.vacancyId, false)
      .then((result) => {
        if (result.data.not_found) {
          this.$router.push({ name: "vacancy-search" });
        }

        this.vacancy = result.data;
      })
      .catch((e) => {
        const status_code = e.response?.status || 404;
        this.$router.push({
          name: "vacancy-error",
          query: { error_code: status_code },
        });
      });
  },
  methods: {
    copyVacancyLink() {
      this.$refs.copyLink.focus();
      document.execCommand("copy");
    },
  },
};
</script>
